import type { TRuleWithTheme } from '@/styles/theme';

// Matches the user menu's disclosure, the other collapsible in this sidebar.
const EXPAND_ANIM_MS = 200;

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
});

// The single grid row animates between 0fr and 1fr, so the list grows to its own content height
// without a hardcoded pixel target. `visibility` flips only once the collapse has played, which keeps
// the links out of the tab order while hidden without cutting the animation short.
// The sidebar's 1.5rem padding is escaped here, above the clipping row, so the rows can reach the
// same 8px gutter the menu items use (see MenuItem) without the count being cut off.
export const collapsible: TRuleWithTheme = () => ({
    display: 'grid',
    gridTemplateRows: '0fr',
    marginRight: '-1rem',
    marginLeft: '-1rem',
    visibility: 'hidden',
    transition: `grid-template-rows ${EXPAND_ANIM_MS}ms ease, visibility 0s linear ${EXPAND_ANIM_MS}ms`,
});

export const collapsibleExpanded: TRuleWithTheme = () => ({
    gridTemplateRows: '1fr',
    visibility: 'visible',
    transition: `grid-template-rows ${EXPAND_ANIM_MS}ms ease, visibility 0s`,
});

// The row collapses to zero height, so the padding below has to sit inside it rather than on it.
export const collapsibleInner: TRuleWithTheme = () => ({
    overflow: 'hidden',
    minHeight: 0,
});

// Figma "Slot": 8px inline padding puts each row's icon 4px right of the parent item's icon, and the
// row's count flush with the parent's chevron.
export const vaults: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    padding: `${theme.spacing(4)} ${theme.spacing(8)}`,
});

export const chevron: TRuleWithTheme<{ expanded: boolean }> = ({ expanded }) => ({
    flexShrink: 0,
    transition: 'transform 0.15s ease',
    transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
});
